import { Stack, Typography } from '@mui/material';
import { TypographyVariant } from '@mui/material/styles/createTypography';
import { MprcClickable } from 'components';
import React from 'react';

interface IProps {
    avatar?: React.ReactNode;
    title: string;
    titleVariant?: TypographyVariant;
    titleUppercase?: boolean;
    subtitle: string;
    subtitleUppercase?: boolean;
    onClick?: () => void;
}

export const TrainingIndexCard: React.FC<IProps> = ({ avatar, title, titleVariant, titleUppercase, subtitle, subtitleUppercase, onClick }) => {
    return (
        <Stack direction="row" spacing={2} alignItems="center">
            {avatar && (onClick
                ? <MprcClickable onClick={onClick}>{avatar}</MprcClickable>
                : avatar)
            }
            <div>
                <Typography variant={titleVariant ?? "body1"} textTransform={titleUppercase ? "uppercase" : "none"}>
                    {title}
                </Typography>
                <Typography variant={"caption"} textTransform={subtitleUppercase ? "uppercase" : "none"}>
                    {subtitle}
                </Typography>
            </div>
        </Stack>
    );
};
